import { render } from "./WithdrawModal.vue?vue&type=template&id=706643b2&scoped=true"
import script from "./WithdrawModal.vue?vue&type=script&lang=js"
export * from "./WithdrawModal.vue?vue&type=script&lang=js"

import "./WithdrawModal.vue?vue&type=style&index=0&id=706643b2&lang=css&scoped=true"

import exportComponent from "/home/runner/work/THEOS-interfaces/THEOS-interfaces/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-706643b2"]])

export default __exports__